/** Context to allow for UI component extensions */

import type { Entity } from '@tunasong/schemas'
import type { Persisted } from '@tunasong/schemas'
import React from 'react'
import type { FC } from 'react'

/**
 * Props for the entity item menu. The host (list item, card) owns the canonical
 * `<Menu>` + `<MenuTrigger>`; the ItemMenu renders the popup (`<MenuContent>`)
 * plus any dialogs its items open. It stays mounted after the menu closes so
 * those dialogs survive.
 */
export interface UIExtensionItemMenuProps {
  entity: Persisted<Entity>
  /** Anchor override for the context-menu gesture. Omit to anchor to the `<MenuTrigger>`. */
  anchorEl?: Element | null
  /** Close the menu. */
  onClose(): void
}

export interface UIExtensions {
  entityList?: {
    /** Drop-down menu content for entity list items. Rendered inside the host's canonical `<Menu>`. */
    ItemMenu?: FC<UIExtensionItemMenuProps>
  }
}

export const UIExtensionsContext = React.createContext<UIExtensions | null>(null)
